<div class="flex items-center justify-between gap-4">
  <h2 class="!m-0">Deposit</h2>
  <pr-deposit-actions
    [deposit]="depositMetadata()"
    [absence]="depositAbsence()"
    [canOverrideDeposit]="canEditAmount()"
    (waiveDeposit)="waiveDeposit.emit($event)"
  />
</div>

@if (depositWarning()) {
  <div [ngClass]="depositRequiredWarningClasses">
    {{ depositWarning() }}
  </div>
}
@if (depositOverrideWarning()) {
  <div
    class="flex items-center justify-between gap-3 rounded-md bg-amber-50 p-3 text-sm font-medium text-amber-900"
    role="alert"
  >
    <span>
      <mat-icon class="mr-1 align-middle text-amber-700">warning</mat-icon>
      {{ depositOverrideWarning() }}
    </span>
    @if (canResetAmount()) {
      <button
        mat-stroked-button
        type="button"
        class="shrink-0"
        aria-label="Reset the deposit to the default amount"
        [matTooltip]="resetAmountTooltip()"
        (click)="resetAmount()"
      >
        Reset
      </button>
    }
  </div>
}
@if (canOptIn()) {
  <mat-slide-toggle
    color="primary"
    [checked]="optedIn()"
    (change)="optInChanged.emit($event.checked)"
  >
    Take a deposit for this appointment
  </mat-slide-toggle>
}

@if (depositInPlay()) {
  <div class="flex flex-wrap items-start gap-4">
    <div class="flex grow flex-col">
      <div class="flex items-center gap-1 text-xs opacity-50">
        Required for <b>{{ sourceLabel() }}</b>
        <mat-icon class="icon-xs" [matTooltip]="sourceTooltip()">
          info
        </mat-icon>
      </div>
      @for (label of requiredByLabels(); track label) {
        <div>{{ label }}</div>
      }
    </div>

    @if (canEditAmount()) {
      <mat-form-field class="w-32" subscriptSizing="dynamic">
        <mat-label>Amount</mat-label>
        <span matTextPrefix>$&nbsp;</span>
        <input
          matInput
          type="number"
          aria-label="Override deposit amount"
          min="0"
          step="0.01"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [(ngModel)]="depositAmountDollars"
          (keyup.enter)="$event.target.blur()"
        />
      </mat-form-field>
    }
  </div>
} @else {
  <p class="m-0 text-sm text-slate-600">
    The current deposit settings do not require a deposit for this appointment.
  </p>
}
@if (depositMetadata()?.status === DepositStatus.Pending) {
  <p class="m-0 text-sm text-blue-700">
    Payment has been requested from the patient but not yet received.
  </p>
}
